/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "tree": {
      "emptyText": "No Data"
    }
  },
  "de-DE": {
    "tree": {
      "emptyText": "Keine Daten"
    }
  },
  "es-ES": {
    "tree": {
      "emptyText": "Sin datos"
    }
  },
  "fr-FR": {
    "tree": {
      "emptyText": "Aucune donnée"
    }
  },
  "it-IT": {
    "tree": {
      "emptyText": "Nessun dato"
    }
  },
  "jp-JP": {
    "tree": {
      "emptyText": "データなし"
    }
  },
  "ko-KO": {
    "tree": {
      "emptyText": "데이터 없음"
    }
  },
  "nl-NL": {
    "tree": {
      "emptyText": "Geen gegevens"
    }
  },
  "pl-PL": {
    "tree": {
      "emptyText": "Brak danych"
    }
  },
  "pt-PT": {
    "tree": {
      "emptyText": "Sem dados"
    }
  },
  "ru-RU": {
    "tree": {
      "emptyText": "Нет данных"
    }
  },
  "tr-TR": {
    "tree": {
      "emptyText": "Veri yok"
    }
  },
  "vi-VN": {
    "tree": {
      "emptyText": "Không có dữ liệu"
    }
  },
  "zh-CN": {
    "tree": {
      "emptyText": "无数据"
    }
  },
  "zh-TW": {
    "tree": {
      "emptyText": "無資料"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
